import React, { Component, useState } from "react";
import coverIcon from "../../images/coverIcon.svg";
import conditionIcon from "../../images/conditionIcon.svg";
import serviceIcon from "../../images/serviceIcon.svg";
import coverIcon_gray from "../../images/coverIcon_gray.svg";
import conditionIcon_gray from "../../images/conditionIcon_gray.svg";
import serviceIcon_gray from "../../images/serviceIcon_gray.svg";
import downloadIcon from "../../images/download-icon.svg";
import downloadIconGray from "../../images/download-icon-gray.svg";

class ConsentMenu extends Component {
  render() {
    const { onChangeTab, menuTab } = this.props;

    return (
      <>
        <div className="tab d-flex mh-40 justify-content-center">
          <div
            className={`tab-header w-30 ${menuTab === 1 ? "active" : ""}`}
            onClick={() => onChangeTab(1)}
          >
            <img src={menuTab === 1 ? coverIcon : coverIcon_gray} />
            <label className="ml-1">ความคุ้มครอง</label>
            <div className={`${menuTab === 1 ? "border" : "none-border"} `} />
          </div>
          <div
            className={`tab-header w-25 ${menuTab === 2 ? "active" : ""}`}
            onClick={() => onChangeTab(2)}
          >
            <img src={menuTab === 2 ? conditionIcon : conditionIcon_gray} />
            <label className="ml-1">เงื่อนไข</label>
            <div className={`${menuTab === 2 ? "border" : "none-border"} `} />
          </div>
          <div
            className={`tab-header w-25 ${menuTab === 3 ? "active" : ""}`}
            onClick={() => onChangeTab(3)}
          >
            <img src={menuTab === 3 ? serviceIcon : serviceIcon_gray} />
            <label className="ml-1">บริการ</label>
            <div className={`${menuTab === 3 ? "border" : "none-border"} `} />
          </div>
          <div
            className={`tab-header w-20 ${menuTab === 4 ? "active" : ""}`}
            onClick={() => onChangeTab(4)}
          >
            <img src={menuTab === 4 ? downloadIcon : downloadIconGray} />
            <label className="ml-1">เอกสาร</label>
            <div className={`${menuTab === 4 ? "border" : "none-border"} `} />
          </div>
        </div>
      </>
    );
  }
}
export default ConsentMenu;
